import React from 'react'
import './TemplatesTable.scss'
import GridItem from 'reactor/components/Grid/GridItem'
import BoxItem from 'reactor/components/Box'
import For from 'reactor/components/For'
import Slider from "react-slick";
import {True, False} from '../../components/TrueOrFalse'
import Link from 'reactor/components/Link'

// const TemplatesOptions = [
//     'لوحة التحكم',
//     'نظام عضويات',
//     'نظام الاستفتاءات',
//     'تصميم القالب',
//     'HTML5, CSS3',
//     'تأثيرات jQuery',
//     'تصميم متجاوب',
//     'الاعلانات',
//     'وسائط',
//     'التصنيفات والصفحات',
//     'نموذج الاتصال بنا',
//     'سعر المنتج'
// ];


// const Templates = [
//     {
//         templatename: 'رواد بريس',
//         dashboard: 'لوحة تحكم عربية',
//         manage: 'لا يتطلب خبرة مسبقة',
//         members: 'التحكم في العضويات',
//         questionnaire: 'التحكم في الإستفتاذات',
//         design: 'إحترافي متجاوب',
//         HTML5CSS3: true,
//         jquery: true,
//         responsivedesign: true,
//         ads: false,
//         media: false,
//         pages: 'لانهائى',
//         contactform: true,
//         price: '399',
//     },
//     {
//         templatename: 'رواد بريس',
//         dashboard: 'لوحة تحكم عربية',
//         manage: 'لا يتطلب خبرة مسبقة',
//         members: 'التحكم في العضويات',
//         questionnaire: 'التحكم في الإستفتاذات',
//         design: 'إحترافي متجاوب',
//         HTML5CSS3: true,
//         jquery: true,
//         responsivedesign: true,
//         ads: true,
//         media: true,
//         pages: 'لانهائى',
//         contactform: true,
//         price: '399',
//     },
//     {
//         templatename: 'رواد بريس',
//         dashboard: 'لوحة تحكم عربية',
//         manage: 'لا يتطلب خبرة مسبقة',
//         members: 'التحكم في العضويات',
//         questionnaire: 'التحكم في الإستفتاذات',
//         design: 'إحترافي متجاوب',
//         HTML5CSS3: true,
//         jquery: true,
//         responsivedesign: true,
//         ads: true,
//         media: true,
//         pages: 'لانهائى',
//         contactform: true,
//         price: '399',
//     },
//     {
//         templatename: 'رواد بريس',
//         dashboard: 'لوحة تحكم عربية',
//         manage: 'لا يتطلب خبرة مسبقة',
//         members: 'التحكم في العضويات',
//         questionnaire: 'التحكم في الإستفتاذات',
//         design: 'إحترافي متجاوب',
//         HTML5CSS3: true,
//         jquery: true,
//         responsivedesign: true,
//         ads: true,
//         media: true,
//         pages: 'لانهائى',
//         contactform: true,
//         price: '399',
//     },

// ];

const settings = {
  dots: false,
  arrows: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 2000,
  slidesToShow: 3,
  slidesToScroll: 1,
  rtl: true,
  responsive: [
    {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
  ],
};

export default function TemplatesTable({options, object}) {

    return (
        <BoxItem display="flex" className="templates_table">
            <GridItem xs={6} sm={4} className="templates_table--rightside">
                <div className="templates_table--head">
                    <p>تفاصيل</p>
                    <h3>القوالب</h3>
                </div>
                <For array={options} render={ option => (
                    <div className="templates_table--options">
                        <span>{option}</span>
                    </div>
                )}
                />
            </GridItem>
            <GridItem xs={6} sm={8}>
                <Slider {...settings}>
                    {/* <For array={Templates} render={ item => ( */}
                    { object.map( (item, index)=> (
                        <div key={index} className="templates_table--item">
                            <div className="templates_table--head">
                                <p>قالب</p>
                                <h3>{item.templatename}</h3>
                            </div>
                            <div className="templates_table--options templates_table--options--price">
                                <p>
                                    {item.price}
                                    <span>ريال / لمرة واحدة</span> 
                                </p>
                            </div>
                            <div className="templates_table--options">
                                <span>{item.manage}</span>
                            </div>
                            <div className="templates_table--options">
                                <span>{item.members}</span>
                            </div>
                            <div className="templates_table--options">
                                <span>{item.questionnaire}</span>
                            </div>
                            <div className="templates_table--options">
                                <span>{item.design}</span>
                            </div>
                            <div className="templates_table--options">
                                {item.HTML5CSS3 === true ?
                                    <True/> : <False />
                                }

                            </div>
                            <div className="templates_table--options">
                                {item.jquery === true ?
                                    <True/> : <False />
                                }
                            </div>
                            <div className="templates_table--options">
                                {item.responsivedesign === true ?
                                    <True/> : <False />
                                }
                            </div>
                            <div className="templates_table--options">
                                {item.en === true ?
                                    <True/> : <False />
                                }
                            </div>
                            <div className="templates_table--options">
                                {item.ads === true ?
                                    <True/> : <False />
                                }
                            </div>
                            <div className="templates_table--options">
                                {item.media === true ?
                                    <True/> : <False />
                                }
                            </div>
                            <div className="templates_table--options">
                                <span>{item.pages}</span>
                            </div>
                            <div className="templates_table--options">
                                {item.contactform === true ?
                                    <True/> : <False />
                                }
                            </div>
                            <div className="templates_table--options">
                                {item.setUp === true ?
                                    <True/> : <False />
                                }
                            </div>
                            <div className="templates_table--options">
                                <span><a href={item.liveLink} target='_blank'>استعراض القالب</a></span>
                            </div>
                            <div className="templates_table--options templates_table--options--price">
                                <p>
                                    <Link href="/contact-us" className={`btn-request templates-${item.class}`}>أطلب الآن</Link>
                                </p>
                            </div>
                        </div>
                        ))}
                </Slider>
            </GridItem>
        </BoxItem>
    )
}